import {
	LICENSED_PRODUCTS,
	getLicensedProducts,
} from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';

const hasJswConfluence = (): boolean => {
	const products = getLicensedProducts();
	const { JIRA_SOFTWARE, CONFLUENCE } = LICENSED_PRODUCTS;
	return products[JIRA_SOFTWARE] && products[CONFLUENCE];
};

export default hasJswConfluence;
